export default {
  isMyParticipantRaisingHand: (state, getters, rootState) => {
    return rootState.myParticipantId in state.raisedHands;
  }
};
